module.exports = __webpack_public_path__ + "img/116.3.02909ea9.png";